import type ExportFilterSchoolClassroom from '@/core/domain/exports/ExportFilterSchoolClassroom.ts'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'
import {
  type ExportFilterSchoolEntity,
  ExportFilterSchoolSchema
} from '@/core/infrastructure/schemas/exports/ExportSchema.ts'

export default class ExportFilterSchool {
  readonly id: number
  readonly name: string
  readonly city: string
  readonly zipCode: string
  readonly classrooms: ExportFilterSchoolClassroom[]

  constructor(school: ExportFilterSchoolEntity) {
    this.id = school.id
    this.name = school.name
    this.city = school.city
    this.zipCode = school.zipCode
    this.classrooms = school.classrooms
  }

  public static create(data: unknown): ExportFilterSchool {
    return EntityValidator.validateAndCreate(
      ExportFilterSchoolSchema,
      data,
      ExportFilterSchool,
      'ExportFilterSchool'
    )
  }
}